import React from 'react';

import * as styles from './PerformanceInsightsSlide.module.scss';

export const PerformanceInsightsSlide = (): React.ReactElement => {
  return (
    <div className={styles.container}>
      <div className={styles.retailImage} />
      <h1 className={`${styles['header-retail-1']} mt-4 mb-2`}>Performance insights that matter</h1>
      <p className={styles['subheader-retail-1']}>
        {`See how your sales stack up against your competitors'`}
        <br />
        {`in the channels most important to you.`}
      </p>
      <p className="text-sm text-inactive mt-2">gfknewron for Retail</p>
    </div>
  );
};
